import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "base-text-editor" }
const _hoisted_2 = {
  key: 0,
  class: "label"
}
const _hoisted_3 = { class: "textarea-editor" }
const _hoisted_4 = ["id"]

import { ref, onMounted } from "vue";
import { bsonId } from "@/common/utils/common";

import Quill from "quill";
import "quill/dist/quill.snow.css";


export default /*@__PURE__*/_defineComponent({
  __name: 'base-text-editor',
  props: {
    modelValue: {}
  },
  emits: ["update:modelValue", "blur"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const editorContainer = ref<HTMLDivElement | null>(null);
const started = ref(false);
const id = ref(bsonId());

onMounted(async () => {
  if (editorContainer.value && !started.value) {
    const SizeStyle = Quill.import("attributors/style/size");
    SizeStyle.whitelist = [
      "0.5rem",
      "0.625rem",
      "0.75rem",
      "0.875rem",
      "1rem",
      "1.125rem",
      "1.25rem",
      "1.5rem",
      "1.75rem",
      "2rem",
      "2.5rem",
    ];
    Quill.register(SizeStyle, true);

    const quill = new Quill(editorContainer.value, {
      theme: "snow",
      modules: {
        toolbar: `#toolbar-${id.value}`,
      },
    });

    await new Promise((resolve) => setTimeout(resolve, 150));

    quill.clipboard.dangerouslyPasteHTML(
      0,
      props.modelValue?.replaceAll("\\", "")
    );
    quill.blur();
    started.value = true;

    quill.on("selection-change", (range) => {
      if (!range) {
        emit("blur");
      }
    });

    quill.on("text-change", () => {
      const content = quill.root.innerHTML;

      emit("update:modelValue", content);
    });
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    (_ctx.$slots.label)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _renderSlot(_ctx.$slots, "label")
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", {
        id: `toolbar-${id.value}`
      }, [...(_cache[0] || (_cache[0] = [
        _createStaticVNode("<select class=\"ql-header\" data-v-a3d03b4a><option value=\"1\" data-v-a3d03b4a>Título 1</option><option value=\"2\" data-v-a3d03b4a>Título 2</option><option value=\"3\" data-v-a3d03b4a>Título 3</option><option value=\"4\" data-v-a3d03b4a>Título 4</option><option selected data-v-a3d03b4a>Normal</option></select><select class=\"ql-size\" data-v-a3d03b4a><option value=\"0.5rem\" data-v-a3d03b4a>8px</option><option value=\"0.625rem\" data-v-a3d03b4a>10px</option><option value=\"0.75rem\" data-v-a3d03b4a>12px</option><option value=\"0.875rem\" data-v-a3d03b4a>14px</option><option value=\"1rem\" selected data-v-a3d03b4a>16px</option><option value=\"1.125rem\" data-v-a3d03b4a>18px</option><option value=\"1.25rem\" data-v-a3d03b4a>20px</option><option value=\"1.5rem\" data-v-a3d03b4a>24px</option><option value=\"1.75rem\" data-v-a3d03b4a>28px</option><option value=\"2rem\" data-v-a3d03b4a>32px</option><option value=\"2.5rem\" data-v-a3d03b4a>40px</option></select><button class=\"ql-bold\" data-v-a3d03b4a></button><button class=\"ql-italic\" data-v-a3d03b4a></button><button class=\"ql-underline\" data-v-a3d03b4a></button><button class=\"ql-strike\" data-v-a3d03b4a></button><select class=\"ql-color\" data-v-a3d03b4a></select><select class=\"ql-background\" data-v-a3d03b4a></select><button class=\"ql-link\" data-v-a3d03b4a></button><button class=\"ql-clean\" data-v-a3d03b4a></button>", 10)
      ]))], 8, _hoisted_4),
      _createElementVNode("div", {
        ref_key: "editorContainer",
        ref: editorContainer
      }, null, 512)
    ])
  ]))
}
}

})